import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { CashIcon, pdfSVG, printButtonSVG } from "../../../assets/SVGs/SVGs";
import useStatusColor from "../../../hooks/useStatusColor";
import { downloadPDF } from "../../../utils/DownloadPdf";
import { handlePrint } from "../../../utils/HandlePrint";
import SaleCardGiftCard from "../../admin/common/SaleCardGiftCard";
import SaleCardMembership from "../../admin/common/SaleCardMembership";
import SaleCardProduct from "../../admin/common/SaleCardProduct";
import SaleCardService from "../../admin/common/SaleCardService";
import SubInfo from "../../admin/common/SubInfo";
import Invoice from "../../sales/ReservationReceipt";
type Props = { record: any };

const SalesRowData = ({ record: data }: Props) => {
  const color = useStatusColor(data?.status);
  const intl = useIntl();
  return (
    <div
      style={{
        border: `1px ${color} solid`,
        borderTop: "0px",
        borderBottomRightRadius: "8px",
        borderBottomLeftRadius: "8px",
      }}
      className="bg-white px-[10px] pb-2"
    >
      <div className="p-4 px-[10px] bg-[#FBFBFF] rounded-lg flex flex-col items-start justify-start w-full gap-[18px] text-sm">
        <div>
          <FormattedMessage id="sales.contents" /> #{data?.id}
        </div>
        <div className="flex flex-col items-center justify-start w-full gap-4">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg text-color-primary">
              <Avatar className="bg-gray" size={24} icon={<UserOutlined />} />
              <div className="flex items-center gap-1">
                <FormattedMessage id="with" />
                <span className="capitalize">
                  {data?.client_profile?.full_name}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              {/* <Button
                className="px-6 py-2 border-none bg-[#EEF0FF] text-sm text-color-primary rounded-lg font-semibold flex items-center gap-1"
                type="default"
              >
                {sendMailSVG}ارسال للعميل
              </Button> */}
              <Button
                className="px-6 py-2 border-none bg-[#EEF0FF] text-sm text-color-primary rounded-lg font-semibold flex items-center gap-1"
                type="default"
                onClick={() => handlePrint(<Invoice data={data} />)}
              >
                {printButtonSVG}
                {intl.formatMessage({
                  id: "print",
                })}
              </Button>
              <Button
                className="px-6 py-2 whitespace-nowrap border-none bg-[#EEF0FF] text-sm text-color-primary rounded-lg font-semibold flex items-center gap-1"
                type="default"
                onClick={() => downloadPDF(<Invoice data={data} />, data?.id)}
              >
                {pdfSVG}
                {intl.formatMessage({
                  id: "downloadPDF",
                })}
              </Button>
            </div>
          </div>
          <div className="grid items-center w-full grid-cols-2 gap-4">
            {
              // Sort items based on a predefined order
              data?.sale_items
                ?.sort((a: any, b: any) => {
                  const order: any = {
                    PricingOption: 1,
                    Product: 2,
                    GiftCardValue: 3,
                    Membership: 4,
                  };
                  return order[a.itemable_type] - order[b.itemable_type];
                })
                .map((e: any) =>
                  e?.itemable_type === "PricingOption" ? (
                    <SaleCardService data={e} />
                  ) : e?.itemable_type === "Product" ? (
                    <SaleCardProduct data={e} />
                  ) : e?.itemable_type === "GiftCardValue" ? (
                    <SaleCardGiftCard data={e} />
                  ) : e?.itemable_type === "Membership" ? (
                    <SaleCardMembership data={e} />
                  ) : null
                )
            }
          </div>

          <div className="flex items-center justify-start w-full gap-6">
            <span className="px-2 py-3 bg-white rounded-lg">
              {" "}
              {intl.formatMessage({
                id: "tips",
              })}
            </span>
            <span className="px-2 py-3 bg-white rounded-lg">
              <SubInfo
                value={data?.tip}
                label={intl.formatMessage({
                  id: "SARshort",
                })}
              />
            </span>
            <div className="flex items-center justify-between w-full px-2 py-3 bg-white rounded-lg">
              <div className="flex items-center gap-3">
                <span>
                  {intl.formatMessage({
                    id: "totalPrice",
                  })}
                </span>
                <span>
                  <SubInfo
                    value={data?.pay}
                    label={intl.formatMessage({
                      id: "SARshort",
                    })}
                  />
                </span>
              </div>
              <span className="text-[#479821] font-semibold flex items-center gap-1">
                {CashIcon} {data?.payment_method?.name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesRowData;
